"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBodySource = void 0;
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const react_intl_1 = require("react-intl");
const snackbar_context_1 = require("../composite/snackbar/snackbar-context");
const abortable_fetch_1 = require("./abortable-fetch");
const event_callback_hook_1 = require("./event-callback-hook");
const serialize_call_hook_1 = require("./serialize-call-hook");
const snackbar_types_1 = require("../composite/snackbar/snackbar-types");
function useBodySource(url) {
    const fetch = react_1.useRef(null);
    const bodyRef = react_1.useRef();
    const dataRef = react_1.useRef({
        items: [],
        count: 0,
    });
    const isDataValidRef = react_1.useRef(false);
    const hasNextPageRef = react_1.useRef(true);
    const [loading, setLoading] = react_1.useState(false);
    const [result, setResult] = react_1.useState(dataRef.current);
    const intl = react_intl_1.useIntl();
    const { showSnackbar } = react_1.useContext(snackbar_context_1.SnackbarContext);
    const loadMoreUnsafe = event_callback_hook_1.useEventCallback(async () => {
        var _a;
        try {
            if (isDataValidRef.current && !hasNextPageRef.current) {
                // skip
                return;
            }
            setLoading(true);
            fetch.current = abortable_fetch_1.abortableFetch(typeof url === 'function' ? url() : url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    ...((_a = bodyRef.current) !== null && _a !== void 0 ? _a : {}),
                }),
            });
            const data = await fetch.current.json();
            if (!isDataValidRef.current) {
                dataRef.current = data;
            }
            else {
                dataRef.current = {
                    ...data,
                    items: [...dataRef.current.items, ...data.items],
                };
            }
            isDataValidRef.current = true;
            hasNextPageRef.current = data.count > dataRef.current.items.length;
            react_dom_1.unstable_batchedUpdates(() => {
                setResult(dataRef.current);
                setLoading(false);
            });
            fetch.current = null;
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                isDataValidRef.current = true;
                hasNextPageRef.current = false;
                const message = intl.formatMessage({
                    id: 'EAS_BODY_SOURCE_MSG_ERROR',
                    defaultMessage: 'Chyba načtení dat: {detail}',
                }, { detail: err.message });
                setLoading(false);
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
            }
        }
        return;
    });
    const [loadMore] = serialize_call_hook_1.useSerializeCall(loadMoreUnsafe);
    const source = react_1.useMemo(() => ({
        ...result,
        loading,
        setLoading,
        loadMore,
        setBody: (p) => (bodyRef.current = p),
        reset: () => {
            var _a;
            (_a = fetch.current) === null || _a === void 0 ? void 0 : _a.abort();
            hasNextPageRef.current = true;
            isDataValidRef.current = false;
        },
        hasNextPage: () => hasNextPageRef.current,
        isDataValid: () => isDataValidRef.current,
    }), [result, loadMore, loading]);
    return source;
}
exports.useBodySource = useBodySource;
//# sourceMappingURL=body-source-hook.js.map